
import pic from '@/utils/pic'
const { icon1, icon2, icon3, langzh, langen,langno, langtw, langjp, langxby,langit,langdy,langfy,langhy,langty,langyn,zhsz, jtrz, sfrz, iconchecked, iconcheck,icon1_01,icon1_02,icon1_03,icon1_04,banner01,banner02,banner03 } = pic

export default {
  currency: {
    bb: 'Exchange',
    bba: 'Exchange Account',
    hy: 'Contracts Deal',
    jg: 'Swap',
    hya: 'Contracts Account'
  },
  index: {
    h24: '24H Volume',
    header_title: ['Choose digital asset trading ' + window.GLOBAL.LANG_TITLE.zh],
    header_small_title:'Complete one-stop blockchain digital asset transaction',
    header_msg: 'security-stable-trustworthy',
    register_title: 'Register a ' + window.GLOBAL.LANG_TITLE.zh + ' global account start trading journey',
    register_pl: 'Please enter your email or mobile number',
    register: 'Register',
    featureTitleWhy: 'Why choose us',
    featureTitle: 'security · stable · reliable',
    featureMsg: '',
    featureList: [
      { icon: icon1, title: 'Secure wallet technology', msg: ['The cold and hot wallet technology is developed by the worlds top security team, and there has never been a coin loss incident.',''] },
      { icon: icon2, title: 'Rich crypto asset business', msg: ['Support spot and multiple derivatives trading, etc., is your personal steward into the world of encrypted assets.',''] },
      { icon: icon3, title: 'Customers distributed all over the world', msg: ['Provide a full range of encrypted assets services for users in more than 130 countries or regions around the world.', ''] }
    ],
    bannerList: [
      {icon: banner01,title: "Committed to providing industry-leading security and stability", msg: ["smart contracts to protect investor asset safety", "real trading performance", "24h service guarantee"] },
      {icon: banner02,title: "I want to buy and sell immediately through simple operations", msg: ["simple trading screen", "immediately reflected in your account balance", "most cryptocurrencies can be traded" ] },
      {icon: banner03,title: "I want to actively earn profits through settlement contract trading", msg: ["Open an account at the same time", "Strategic investment for a large number of trading futures", "You can trade 24 hours a day, 365 days a year , Even on weekends"]}
    ],
    featureList2: [
      {icon: icon1_01, title: "Transparency and Openness", msg: ["Using the characteristics of blockchain and smart contracts, realizing transaction performance on the chain, and using smart contracts to ensure the safety of investors’ assets",""] },
      {icon: icon1_02, title: "Smart Investment", msg: ["With the diversified strategies provided by top quantitative trading experts, you are free to choose",""] },
      {icon: icon1_03, title: "Risk grading", msg: ["Design diversified investment products based on the different risks and asset management preferences of each investor, effectively eliminating investment thresholds", ""] },
      {icon: icon1_04, title: "Diversified products", msg: ["Provide various types of user investment needs and flexible platform mechanisms, and continue to produce innovative financial services that are better than the market", ""]}
    ],
    featureTitle2: 'Multi-platform terminal transaction anytime, anywhere',
    featureMsg2: 'Covering multiple platforms of iOS and Android, supporting full-service functions',
    tab: ['Mainstream currency', '24H increase list'],
    thead: ['Name', 'Latest price', 'Highest price of the day', 'Lowest of the day', 'Increase list', '24H volume', 'Operate'],
    more: 'more >',
    btn: 'Screen Trading',
    dealsTitle: 'One-stop trading service',
    dealsTab:[
      { title: 'Exchange', content: 'Currency trading is for the exchange between digital assets, using USDT as the unit of valuation to purchase other currencies.'+window.GLOBAL.LANG_TITLE.zh+'Currency transactions support real-time transactions of digital assets such as Bitcoin, Ethereum, and Litecoin.', src:'/static/image/deals-1.jpg', path: '' },
      { title: 'Contract', content: 'A financial derivative of a digital currency not only supports the choice to buy long or short contracts to earn income, but also is simple to operate and never expires.'+window.GLOBAL.LANG_TITLE.zh+'The contract has an advanced risk management system with leverage up to 100 times.', src:'/static/image/deals-2.jpg', path: '' }
    ]
  },
  market: {
    tab: ['Favorites', 'Contract', 'Exchange'],
    thead: ['Pair', 'Latest price', '24H change', '24H Lowest', '24H Highest','24H volume', 'Operate'],
    nodata: 'No data'
  },
  footer: {
    p: '©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
    dd: [
      {
        dt: "About us",
        dd: [{ title: "Company Profile", id: 1 }, { title: "Help center", type: 'help' }]
      },
      {
        dt: "User support",
        dd: [
          { title: "User Agreement", id: 3 },
          { title: "Privacy Policy", id: 5 }
        ]
      },
      {
        dt: "Contact us",
        icon: true
      }
    ]
  },
  nav: {
    btn: ["Login", "Register", "Asset Management","Download APP"],
    nav: [
      { title: "Home", path: "/index",name: 'index' },
      { title: "Market", path: "/market",name: 'market' },
      // { title: "Exchange", path: "/deal", name: 'deal'},
      // { title: "Contract", path: "/deal_c", name: 'deal_c' },
      { title: "Swap", path: "/deal_jg", name: 'deal_jg' },
      { title: "Holding Rebates", path: "/profit_index",name: 'profit_index' }
    ],
    nav2: [{ title: "My assets", path: "/asset" }],
    menus: [
      { icon: langzh, title: "User Center", path: "/setting" },
      { icon: langen, title: "sign out" }
    ],
    lang: [
      { icon: langen, lang: "English", key: 'en' },
      {
        icon: langno,
        lang: "Norsk",
        key: 'no'
      },
      {"icon": langit,"lang": "Italiano","key": "it"},
      { icon: langxby, lang: "España", key: 'es' },
      { icon: langfy, lang: "français", key: 'fr' },
      { icon: langdy, lang: "Deutsche", key: 'de' },
      { icon: langjp, lang: "日本語", key: 'jp' },
      { icon: langhy, lang: "한국어", key: 'kr' },
      { icon: langty, lang: "ไทย", key: 'th' },
      { icon: langyn, lang: "Tiếng Việt", key: 'vn' },
      { icon: langzh, lang: "简体中文", key: 'zh' },
      { icon: langtw, lang: "繁體中文", key: 'tw' },
    ]
  },
  download:{
    "xz": "Download"
  },
  // 登录
  login: {
    login: 'Login please',
    msg: 'Please enter your registered account',
    list: ['Mobile / Email', 'Password', 'Forgot password?', 'Login', 'No account? Sign up now'],
    message: 'Account or password cannot be empty'
  },
  register: {
    dl: ['Mobile registration', 'Email registration'],
    title: 'Register an account',
    country: 'Country',
    country_info: 'Nationality information cannot be modified after registration, please make sure to choose truthfully',
    account: 'Account',
    code_text: 'verification code',
    code_btn: 'Get CAPTCHA',
    code_unit: 's',
    code_no_data: 'verification code must be filled',
    password_text: 'Password',
    password_again_text: 'Password again',
    pid_text: 'Invitation code',
    pid_pl: 'Optional',
    invitation_code_no_data: 'Invitation code is required',
    xy: 'User Agreement',
    xy_no_checked: 'Please select agreement',
    agree: 'I have read and agree',
    register_btn: 'Register',
    bz: ['The nationality information cannot be modified after registration, please make sure to choose truthfully.', 'The verification email may be misjudged as spam, please check it carefully.', 'Please keep your' + window.GLOBAL.LANG_TITLE.zh + 'Account number and login password. ','Do not use the same login password as other websites.'],
    account_no_data: 'Account number cannot be empty',
    code_no_equality: 'Verification codes are not equal',
    password_no_data: 'Password cannot be empty',
    password_no_equality: 'The two passwords do not match'
  },
  // 设置密码
  bindmpwd: {
    title: 'Set password',
    account: 'Account',
    code_text: 'verification code',
    code_btn: 'Get CAPTCHA',
    code_unit: 's',
    password_text: 'Password',
    password_again_text: 'Password again',
    code_no_data: 'verification code must be filled',
    code_no_equality: 'Verification codes are not equal',
    password_no_data: 'Password cannot be empty',
    password_no_equality: 'The two passwords do not match',
    bindmpwd_btn: 'OK',
    phone_no_data: 'Mobile number cannot be empty',
    password_login_text: 'Please enter the login password',
    password_trade_text: 'Password length 6 digits',
    password_again_tarde_text: 'Password length 6 digits',
  },
  // 忘记密码
  forgetpwd: {
    title: ['Modify password', 'Forgot your password'],
    account: 'Account',
    code_text: 'verification code',
    code_btn: 'Get CAPTCHA',
    code_unit: 's',
    password_text: 'Password',
    password_again_text: 'Password again',

    phone_no_data: 'Mobile number cannot be empty',

    account_no_data: 'Account number cannot be empty',
    code_no_data: 'verification code must be filled',
    code_no_equality: 'Verification codes are not equal',
    password_no_data: 'Password cannot be empty',
    password_no_equality: 'The two passwords do not match',
    forgetpwd_btn: 'OK'
  },
  // 绑定手机号码
  bindphone: {
    title: 'Bind mobile phone number',
    phone_text: 'Phone number',
  },
  person: {
    more: 'Load more',
    no_more: 'No more data',
    index_center:"User Center",
    index_menus: [
      { icon: zhsz, title: "Account management", path: '/setting' },
      { icon: sfrz, title: "KYC authentication", path: '/sfyz' },
      { icon: sfrz, title: "Junior certification", path: '/smauth' },
      { icon: sfrz, title: "Senior certification", path: '/seniorauth' },
      { icon: jtrz, title: "Address authentication", path: '/dzrz' },
      { icon: jtrz, title: "Buy Crypto", path: '/kjmbSelect' },
      { icon: jtrz, title: "Credit score", path: '/credit' },
      { icon: jtrz, title: "Account details", path: '/deallog' },
      { icon: jtrz, title: "Deposit record", path: '/cbjl' },
      { icon: jtrz, title: "Withdrawal record", path: '/tbjl' },
    ],
    cbtb: 'Deposit & Withdraw',
    jymx: 'Transaction details',
    xyf: {
      'title': 'Credit score',
      'pgsj': 'Evaluation time'
    },
    smrz:{
       title:'KYC Authentication' ,
       sure_title:'You are authenticated',
       zj_type:'Types of valid ID' ,
       zj_info:['1. Once the authentication information is verified, it cannot be modified. Please fill in',' truthfully. 2. The authenticated real-name information cannot be re-certified.'],
       zj_name:'Name' ,
       zj_num:'ID number' ,
       zj_btn:'OK' ,
       zj_rebtn:'Re-verify' ,
       zj_sebtn:'Advanced verification' ,
       zj_type_array:[{name:'ID card',type:'idcard'}],
       idCardArr: [
        {
            id: 1,
            name: "ID card"
        },
        {
            id: 2,
            name: "Passport"
        },
        {
            id: 3,
            name: "Driver's license"
        },
        {
            id: 4,
            name: "Resident permit"
        },
        {
            id: 5,
            name: "Other"
        }
       ],
       zj_data:{city:'Nationality cannot be empty',type:'Credential type cannot be empty',name:'The name cannot be empty',zj_num:'ID number cannot be empty'},
       zsxm: 'Real Name',
       qsrzsxm: 'Please enter your real name',
       zjlx: 'Types of valid ID',
       qxzzjlx: 'Please select Types of valid ID',
       sfz: 'ID card',
       zjhm: 'ID number',
       qsrzjhm: 'Please enter the ID number',
       sczjz: 'Upload ID photos',
       zjzm: 'Upload photo of front of ID document',
       zjfm: 'Upload photo of back of ID document',
       qsczjzm: 'Please Upload photo of front of ID document',
       qsczjfm: 'Please Upload photo of back of ID document',
       scqmz: 'Upload ID documents and personal signature',
       qscscqmz: 'Please Upload ID documents and personal signature',
       zj: [
         {
           id: 1,
           title: 'ID card'
         },
         {
           id: 2,
           title: 'Passport'
         },
         {
           id: 3,
           title: 'Other'
         },
       ],
       tj: 'Submit',
       shz: 'Under review',
       shtg: 'Approved'
    },
    gjrz:{
      title:'Senior certification',
      zj_info:['1. Images smaller than 8MB and in JPG JPEG or PNG formats are supported.','2. ID document photos must be clear and shall not be modified or blocked. The personal photo document number and document holder’s name must be clearly visible.','3. Photos must be taken without any headwear and are recommended to not include the use of makeup. The facial features of the photo should be clear and recognizable and their arms should be fully exposed.'],
      zj_img:['/static/image/User_Center_Front_view.png','/static/image/User_Center_Back_Shot.png','/static/image/User_Center_Full_picture.png'],

    },
    zhgl:{
      title:'Security Settings',
      bind:[{bind_title:'Reset password',bind_name:'Email'},{bind_title:'Set withdrawal password',bind_name:'Email'}]
    },
    wdtg:{
      own_code:'Exclusive invitation code',
      own_code_url:'Exclusive invitation link',
      own_push_title:'My promotion',
      own_push_content:['Total invitation revenue (valuation)','Number of invitations',' people'],
      own_push_content_profit:['1st invitation revenue','2nd invitation revenue','3rd invitation income','4th invitation income'],
      own_push_content_num:['1st Number of invitations','2nd Number of invitations','3rd Number of invitations','4th Number of invitations'],
      own_push_profit_title: ['ID', 'Earnings', 'Remarks info','add time'],
      own_push_num_title: ['ID', 'Name', 'Tele','add time'],
    },
    jyzt_td: ['Time', 'Details', 'Amount'],
    cbjl_td: ['Time', 'Currency', 'amount','status'],
    sfrz_txt: ['KYC Authentication ', 'You have submitted the review, please wait for the result', 'You have passed Senior certification', ' front of ID document', 'back of ID document', 'verification','verification failed，Please re-verify'],

    zhsz_txt: ['Your account security level: #', 'Your account security level: #，Improve more information to ensure account security'],
    zhsz_m: 'Strong',
    zhsz_n: 'Weak',
    zhsz_p: 'dangerous',
    zhsz_detailList: [
      // { icon: iconchecked, title: '我的邀请码', value: '', btn: '复制邀请码', class: 'copy', event: 'copy' },
      // { icon: '/static/image/User_Center-email.png', title: '邮箱', value: '用于登录、提币、安全设置时使用', value2:'',btn: '绑定', btn2: '已绑定', path2: '/bindphone' },

      // { icon: '/static/image/User_Center-phone.png', title: '手机', value: '用于提现，修改密码，安全设置时用以收取验证短信', value2:'', btn: '绑定', btn2: '已绑定', path2: '/bindphone' },
      { icon: '/static/image/User_Center-password.png', title: 'Login password', value: 'Internet accounts are at risk of being stolen. It is recommended that you change your password regularly to protect the security of your account.',value2:'', btn: 'Modify',bind_email:'Please bind your email or mobile phone first', path: '/forgetpwd?type=changepwd' },
      { icon: '/static/image/User_Center-password.png', title: 'transaction password', value: 'Set password', btn: 'Go to set', path: '/bindmpwd' }
    ],
    sksz_txt: ['Collection settings', 'Save'],
    sksz_list: [
      { label: "Username:", pl: "Please enter user name", key: "name" },
      { label: "Name on the bank account:", pl: "Please enter the name on the bank account", key: "bank_name" },
      { label: "Bank Account:", pl: "Please enter bank account number", key: "bank_number" },
      { label: "Alipay account:", pl: "Please enter your Alipay account", key: "alipay_account" },
      { label: "WeChat nickname：", pl: "Please enter WeChat nickname", key: "weixin_nickname" },
      { label: "WeChat account:", pl: "Please enter WeChat account", key: "weixin_account" }
    ]
  },
  pasination: {
    first: 'Home',
    prev: 'Previous page',
    next: 'Next page',
    last: 'Last page',
    no_data: 'No data',
  },
  asset: {
    title: 'My assets',
    zjhz: 'Fund transfer',
    cb: 'Deposit',
    gz: 'USDT valuation',
    atnv: [],
    zh_title: 'Total assets converted',
    index_title: 'Assets',
    address_title: 'Currency',
    address_txt: ['Please choose', 'Withdrawal address', 'Please enter content', 'Remarks', 'Address list'],
    address_btn: ['Add to', 'Save', 'Delete', 'Edit'],
    address_td: ['Currency', 'Withdrawal address', 'Remarks', 'Operate'],
    currency_td: ['Currency', 'Available', 'Freeze', 'Convert'],

    table_title: 'Total assets',
    table_address_title: 'Withdrawal address management',
    table_td: ['Currency', 'Available', 'Freeze', 'Convert', 'Operate'],
    table_btn: ['Deposit', 'Withdrawal', 'Records', 'Transfer'],

    money_text: ['Withdrawal address', 'Please choose', 'Amount', 'Available:', 'Fee',
      'Arrival amount', 'Transaction password','Tag (Memo)','Minimum '],
    money_btn: 'Withdrawal',
    xzbz: 'Currency selection',
    money_msg: ['Reminder:', '1. Withdrawal time is 12:00-24:00 Hong Kong time, and you can submit two withdrawal applications per day (minimum withdrawal is 100u, maximum withdrawal is 200,000u);', '2. At present, the withdrawal only supports USDT currency, and the wallet link type selects ERC20;',' 3. After submitting the withdrawal application, the funds are in a frozen state because the withdrawal is in progress, and the funds are temporarily managed by the system and cannot be At your disposal. It does not mean that you have lost the asset or the asset is abnormal. Please wait patiently for the approval;','4. The arrival time after submitting the withdrawal application is subject to the block confirmation time. If the withdrawal is not expected after the withdrawal time, please consult the customer service for inquiries;','5. To prevent Set the current behavior, 90% of the total consumption amount is required to initiate a withdrawal'],

    recharge_title: 'Deposit address',
    recharge_btn: ['Copy', 'QR code', 'Deposit'],
    recharge_text: ['Amount', 'Reminder', 'Please do not top up any assets that are not in this currency to the above address otherwise the assets cannot be retrieved.', 'USDT deposits only support the simple send method. Deposits using other methods (send all) cannot be posted temporarily. Please understand.', 'Voucher', 'Voucher description(Optional)','Chain name'],

    record_title: 'Financial records',
    record_td: ['Amount', 'Records', 'Time'],

    transfer_title: 'Transfer',
    transfer_btn: ['All', 'Transfer'],
    transfer_text: ['From', 'To', 'Please enter the transfer amount', 'Available:'],
    "bq": "Tag(Memo)",
    "qsrbq":"Please enter the tag",
    "yhktx":"Bank card withdrawal",
    "yhmc": "Bank Name",
    "qsryhmc": "Please enter the Bank name",
    "yhzh": "Bank Account ",
    "qsryhzh":"Please enter the Bank account",
    "gjhkdm": "SWIFT Code",
    "qsrgjhkdm":"Please enter the SWIFT Code",
    "yhdz": "Bank address",
    "qsryhdz":"Please enter the Bank address",
    "skrxm": "Payee Name",
    "qsrskrxm":"Please enter the Payee name",
    "skrdh": "Payee Phone",
    "qsrskrdh":"Please enter the Payee phone",
    "skrdz": "Payee Address",
    "qsrskrdz":"Please enter the Payee address"
  },
  text: {
    btn: 'Back',
    login: 'Please sign in'
  },
  deal: {
    chooseType: 'Commission type',
    choose: 'Please select',
    balance: 'Balance',
    account: ['Account', 'Available', '/Freeze', 'Transfer'],
    dir: ['Buy', 'Sell'],
    dir2: ['Available', 'Marketable'],
    cs: 'Favorites',
    sxf: 'Fee',
    jye: 'Turnover',
    sc_list: ['Market', 'Name', 'Increase'],
    sc_h: ['Latest', '24H Lowest', '24H Highest', '24H Vol.'],
    td_lt: ['Currency', 'Latest price', 'Increase'],
    k_line_txt: ['≈', '', 'Increase', 'Highest price', 'Lowest price', '24H Volume'],
    tabListLTitle: ["Current order", "Historical entrustment"],
    tabListLEntrust: ["Buy", "Sell"],
    tabListRTitle: ["Limit", "Market"],
    table_btn: ['Withdrawal'],
    index_td_l: ['Time', 'Trading', 'Amount', 'Price', 'Operate'],
    index_td_r: ['Latest price', 'Direction', 'Price', 'Amount'],
    index_td_r2: ['Latest transaction', 'Time', 'Price', 'Trading volume'],
    table_txt: ['Completed', 'Withdrawn'],

    db_1_txt: ['Available', 'Buying price', 'Selling price', 'Buying volume', 'Sell volume', 'Turnover', 'Buy at the best price in the market', 'Sell at the best price in the market', 'Buy lots', 'Sell lots'],
    db_2_txt: ['Price', 'Leverage', 'Please choose', 'Lots', '1lot =', 'Lots', 'Contract market value', 'Margin', 'Buy at the best price in the market', 'Sell at the best price in the market'],
    pathList: ['Contract record', 'Transaction Record'],
    db_btn: ['Buy(Long)', 'Sell(Short)'],
    tabListLTitle2: ['Current order'],

    lt_btn: ['One-click liquidation', 'Take profit & stop loss', 'Close', 'Submit now', 'Back'],
    lt_txt: ['Risk rate:', 'Total profit'],
    lt_td: ['Type','Leverage', 'Position price', 'Current price', 'Margin', 'Take Profit Price', 'Stop-loss price', 'Opening time', 'Lot', 'Profit&loss', 'Operation'],
    lt_dl: ['Take profit & stop loss', 'Take Profit Price', 'Stop-loss price'],

    lt_0_btn: ['Withdrawal'],
    lt_0_td: ['Contact details', 'Currency', 'Amount', 'Current price', 'Fee', 'Operate'],

    lt_1_btn: ['Close'],
    lt_1_txt: ['Closing'],
    lt_1_td: ['Type', 'Position price', 'Current price', 'Margin', 'Take Profit Price', 'Stop-loss price', 'Opening time', 'Fee', 'Profit&loss', 'Operate'],
    node_data: 'No data',

    lt_3_txt: ['Closed', 'Liquidation'],
    lt_3_td: ['Pype', 'Lots', 'Position price', 'Closing price', 'Take Profit Price', 'Stop-loss price', 'Margin', 'Available margin', 'Opening time', 'Closing time', 'Fee',
      'Profit&loss', 'Operate'],

    lt_4_txt: ['Withdrawn'],
    cm: ['Publish time', 'Total issuance', 'Total circulation', 'Total price', 'Official website','White paper','Introduction'],
    qsrsl: 'Please enter the quantity',
    qsrss: 'Please enter Lots',
  },
  notice:{
      notice_title:'Announcement Center',
  },
  bzhl:{
    title: 'Holding Rebates',
    ttzbt: 'Keep making money every day',
    wdtg: 'Escrow order',
    zztgdzj: 'Funds in custody',
    yjjrsy: 'Estimated daily',
    ljsy: 'Cumulative income',
    tgzdd: 'Order in custody',
    tgdd: 'Escrow order',
    t1: 'Low-risk and stable financial management, redeemable at any time if necessary',
    t2: 'Your free money management assistant',
    cljxcp: 'Product cycle',
    dbxe: 'Single limit',
    rsyl: 'Yield(%)',
    rsyl2: 'Daily return rate:',
    zq: 'Cycle',
    qmr: 'Go buy',
    ckgd: 'More',
    cpgk: 'Product Overview',
    pxsj: 'Dividend payout time',
    tgzj: 'Custody capital',
    tqsh: 'Early redemption',
    cpld: 'Product highlights',
    cpgz: 'Event Rules',
    cont: 'USDT earning are managed by the platforms professional team by hosting USDT on the platform. Participants can obtain the platforms revenue share during the fund hosting period, which can be accessed at any time, which is safe and convenient.',
    zj: '100% funding',
    aqbz: 'Security',
    jjrsy: 'Holiday income',
    bjd: 'Uninterrupted',
    cgcrh: 'After successful deposit',
    dtqx: 'Calculate interest on the day',
    ljzr: 'Transfer now',
    xqglgj: 'Free money management tools',
    ddh: 'Order number',
    tgje: 'Custody amount',
    tgsj: 'Cycle days',
    yhl: 'Profited/Days remaining',
    xdsj: 'Ordering time',
    zt: 'Status',
    fh: 'Back',
    qrnhsy: '7day annualized income',
    ygy: '1 month',
    bn: 'Half a year',
    yn: '1 year',
    yuan: '$',
    tzfx: 'investment risk',
    shsc: 'Redemption time',
    di: 'Low',
    yggzr: '1 working day',
    msgsxf: 'Free subscription fee',
    mr: 'Daily',
    dqfh: 'Return when due',
    ljgm: 'Buy now',
    tgz: 'Order in custody',
    sh: 'Early redemption',
    ywc: 'Completed',
    ysh: 'Redeemed',
    all: 'All',
    "xzbzts": "Simple and safe. Dividends can be selected in multiple currencies",
    "qtbz": "Other coins"
  },
  pay:{
    qsrjymm: 'Please enter 6-digit transaction password',
    tbmmts: 'Please go to the user center to set the transaction password',
  },
  tips:{
    qxztbdz: 'Please enter the withdrawal address',
    qsrtbsl: 'Please enter the quantity of the withdrawal currency'
  },
  statusText: ['Failure','Processing','Success'],
  dzrz: {
    title: 'Address authentication',
    sdddz: 'Utility bill address',
    zdtpsc: 'Bill image upload',
    qsrsdddz: 'You need to fill in the address information and submit the utility bill or broadband address bill',
    qsczdtp: 'Please upload a picture of the bill',
    status: ['Under review','Approved'],
    qd: 'OK',
  },
  jgcc: {
    wtgd: 'Pending order',
    cj: 'Deal',
    jj: 'Info',
    zc: 'Current',
    lszc: 'Historical',
    qblx: 'All',
    xj: 'Current price',
    sj: 'Time',
    fx: 'Direction',
    jg: 'Price',
    sl: 'Amount',
    jgsj: 'Delivery time',
    gmj: 'Purchase price',
    jsj: 'Settlement price',
    yk: 'Profit',
    xq: 'Details',
    mz: 'Buy Long',
    md: 'Sell Short',
    dqye: 'Current balance',
    gb: 'Close',
    jxxd: 'Continue to place an order',
    qrxd: 'Confirm',
    ddqr: 'Order Confirmation',
    sxf: 'Fee',
    kyye: 'Balance',
    jypz: 'Name',
    jyfx: 'Direction',
    tzje: 'Investment price',
    tzjeTips: 'Lowest price 0',
    dqsj: 'Expiry time',
    jssj: 'Delivery time',
    gmsj: 'Purchase time',
    sy: 'Revenue',
    zxje: 'Minimum amount ',
    shi: 'H',
    fen: 'M',
    miao: 's',
    zdje: 'Maximum amount ',
    qsrje: 'Please enter the amount',
    zxtzje: 'Min Qty ',
    yebz: 'Insufficient balance',
    xq: 'Details',
    ddz: 'Waiting',
    jgjl: 'Swap record',
    bz: 'Currency',
    cz: 'Operate'
  },
  kjmb: {
    title: 'Buy Crypto',
    fzcg: 'Copy successfully',
    ljmb: 'Buy Crypto',
    lxkf: 'Contact Customer Service'
  },
  news: {
    title: 'My message',
    "gg":"Notice",
    ckxq: 'View details'
  },
  statusTabs:['Pending order', 'Trading','Closed', 'Withdrawn'],
  "chongzhi":{
    "zy": "Important",
    "cbxx": "Token Deposit Information",
    "qsrsl": "Please enter the deposit amount",
    "tips2": "1. Wallet/platform compatibility: that is, the network is supported; if the target platform does not support your withdrawal network, the assets cannot be retrieved.",
    "tips3": "2. Your top-up network and the target platform are the same; if you choose the target address is the Ethereum network, but the top-up chooses the TRC20 smart chain, you may not be able to retrieve your digital assets.",
    "tips4": "3. Make sure your address and amount are correct before recharging.",
    "tips5": "Reminder: Due to the anonymity and privacy of the block network, once you enter the wrong information, you will lose the corresponding assets. Please check your recharge address and quantity carefully",
    "tips2_1": "• Please do not charge any non-local currency assets to the above address, otherwise the assets cannot be retrieved.",
    "tips2_2": "• The digital currency cannot be delivered in time. The actual arrival time depends on the confirmation speed of the blockchain.",
    "tips2_3": "• Your recharge address will not change frequently, you can recharge; if there is any change, we will try our best to notify you via website announcement or email.",
  },
  "tibi":{
    "tbxx":"Withdrawal Information",
    "qsrbq": "Please enter a label",
    "tbTips1": "• To ensure the safety of funds, when your account security policy changes, password changes, we will manually review the withdrawal, please wait patiently for the staff to contact you by phone or email.",
    "tbTips2": "• Please make sure that your computer and browser are safe to prevent information from being tampered with or leaked.",
    "tbTips3": "• The digital asset you mentioned is a one-coin multi-chain asset. No matter which chain you choose to raise from, it means that the total amount of digital assets displayed on the withdrawal page you own will be reduced by the corresponding amount raised .",
  },
  "gjlb": "Country list",
  "qxzgjlb": "Please select country / Region",
  "mbwt":{
    "title": "Security issues",
    "mbwt": "Security issues",
    "problem":[
      {
        "id": 1,
        "title": "Who is your best friend?"
      },
      {
        "id": 2,
        "title": "Who is your idol?"
      },
      {
        "id": 3,
        "title": "Where is your most yearning place?"
      }
    ],
    "qtxda": "Please fill in the answer",
    "qsrxmm": "Please enter a new password",
    "qqrmm": "Please confirm your password",
    "sydqmmcz": "Use current password reset",
    "zhmm": "Security issues Retrieve password",
    "ysz": "Has been set",
    "tg": "Ignore",
    "tj": "Submit",
    "zyts": "Important:",
    "zytsCont": "Do not disclose the secret answer and verification code, and keep in mind the security issue, which will help you retrieve your password"
  },
  "zc":{
    "zclb": "Asset List",
    "zczh": "Equivalence of assets",
    "yczc": "Hide assets you don't have"
  },
  "indexNew":{
    "t1": "Global Leading",
    "t2": "Digital Asset Service Platform",
    "t3": "Complete one-stop blockchain digital asset transaction",
    "t4": "Mobile Number/Email",
    "t5": "Register Now",
    "t6": "Welcome customers from all over the world through GMO Global",
    "t7":"Discover and start their encryption journey"
  },
  "newReg":{
    "dl": ['Email','Mobile'],
    "cjzh": "Create Account",
    "sysjhzyx": "Register with mobile number/email",
    "yhxy": "&lt;User Agreement&gt;",
    "yhxy2": "I have read and agree to the  and  &lt;User Agreement&gt; ",
    "yxgz": "Input mailboxes do not conform to the rules",
    "dhgz": "The mobile phone number is incorrect"
  },
  "indexNew2":{
    "t1": "Trade on our order",
    "t2": "Use Bitbank",
    "t3": "Bitbank is an ingeniously designed exchange of bitcoin and encrypted assets. It is very simple, convenient, safe and powerful. It supports transactions on multiple web and smart phone platforms. Transaction data and charts are updated in real time. Comprehensive market price analysis provides more than 60 technical analysis tools. Start trading",
    "ksjy": "Start trading",
    "ly": "5 reasons to choose Bitbank",
    "item1_t1": "Leading trading volume",
    "item1_t2": "No.1 * Crypto Asset Trading Volume",
    "item1_t3": "High liquidity, comfortable (pleasant trading experience) trading. List 12 types of crypto assets.",
    "item2_t1": "High third-party evaluation",
    "item2_t2": "Secure trading environment",
    "item2_t3": "Use offline cold wallet. Use Multisig to keep hackers out. Protect your assets with high technology",
    "item3_t1": "Easy to use and reliable application",
    "item3_t2": "Easy to use and simple application",
    "item3_t3": "A reliable application with rich functions. It can maintain trading opportunities outside of the transaction.",
    "item4_t1": "Open all day",
    "item4_t2": "Can deposit gold",
    "item4_t3": "24-hour deposit support, including holidays!",
    "item5_t1": "Smartphone and PC",
    "item5_t2": "Humanized Design",
    "item5_t3": "Even if you use a smart phone, you can perform simple and qualified transactions without hesitation",
    "aqkk": "Safe and reliable",
    "aqkk2": "Bitbank Bitcoin Transaction",
    "cjzh": "Create an account",
  },
  "xbsg":{
    "title": "Newcoin",
    "wdsg": "Details",
    "scts": "Lockup days: ",
    "sy": "Remaining",
    "ljsg": "Subscribe now",
    "ysk": "Sold out",
    "xzjdy": "Subscribe now",
    "dy": "Subscribe",
    "fxjg": "issue price",
    "fxl": "Circulation",
    "ssrq": "Listing date",
    "yxqx": "Validity period",
    "qsrsl": "Please enter amount",
    "syl": "Remaining",
    "sgrq": "subscribe",
    "sgsl": "Amount",
    "bz": "Coin",
    "yebz": "Insufficient USDT balance",
    "tgsl": "Pass Qty",
    "shz": "under review",
    "wtg": "Did not pass",
    "ytg": "passed"
  },
  "wydb":{
    "title": "Borrow",
    "db": "Borrow",
    "dbz": "Borrow",
    "jl": "record",
    "jdzq": "Period (days)",
    "qhk": "To repay",
    "ljdb": "Cumulative(usdt)",
    "dhkbs" :"pending payment",
    "jkje": "Loan amount(usdt)",
    "qsrje": "Please enter amount",
    "rll": "Daily interest rate",
    "hkfs": "Repayment",
    "dqych": "Expired",
    "lx": "Interest",
    "fkjg": "Lender",
    "tpsc": "Credit loan (image upload)",
    "fwxx": "Housing information",
    "srzm": "Proof of income (employment relationship)",
    "yhmx": "Bank statement",
    "zjz": "ID photo",
    "yd": "I have read and agreed",
    "xy": "Apply for a loan agreement",
    "sqdb": "Click to apply for loan chains",
    "gb": "close",
    "qd": "OK",
    "ts": "Please check Apply for a loan agreement",
    "dbjl": "record",
    "hkhth": "Order Code",
    "wsh": "Unreviewed",
    "yfk": "Loan",
    "sqrq": "Application time",
    "zq": "cycle",
    "dbsl": "Number of ribs",
    "zhke": "Total payment",
    "yhkxq": "Repayment Details",
    "bqyhk": "Repayable in the current period(USDT)",
    "hktips": "Please make sure the balance is sufficient, if the balance is insufficient, please recharge first and then repay",
    "bj": "Principal",
    "jie": "Borrow",
    "ljhk": "Repay immediately",
    "qcz": "To deposit",
    "yebzqxcz": "Insufficient balance, please recharge first and then repay",
    "znj": "Late payment fee",
    "yqts": "Days Overdue"
  },
  "hkxq":{
    "dd":"Order",
    "fzhkdz":"Copy the repayment address",
    "hkxq": "Repayment Details",
    "zlx": "total interest",
    "zhk": "total repayments",
    "hkjg": "repayment agency",
    "qschkpz": "Please upload the repayment certificate",
    "hkpz": "repayment certificate"
  },
  "bbjyNew":{
    "jylx": "Types of",
    "jyze": "Amount"
  },
  "bind":{
    "title": "Email Authentication",
    "ybd": "Bound",
    "wbd": "Unbound",
    "ts": "To protect your account, it is recommended to bind an email address",
    "qsryxdz": "email address"
  },
  "tipsNew": {
    "yjj": "rejected",
    "shz": "Redemption"
  },
  "newIndex2":{
    "zxhy": "Latest Quotes",
    "jypt": "Trading Platform",
    "dqwz": "Current position",
    "yzm": "Verification Code",
    "qrmm": "Confirm Password",
    "djdl": "Click to log in",
    "ghdjy": "Better deal",
    "ghdsh": "Better life",
    "about": "The world's most innovative crypto exchange center is here, where you can buy, trade and earn cryptocurrencies with hundreds of cryptocurrencies at your fingertips.",
    "index01": "Your gateway to Bitcoin and beyond",
    "index02": "The world's leading digital asset service platform",
    "index03": "All transactions are free",
    "index04": "Account opening fee, account maintenance fee, stop loss fee, deposit fee, storage/delivery fee are all free.",
    "index05": "Safe and secure security",
    "index06": "Utilizing the expertise GMG INT has accumulated since its inception, we are building robust systems and implementing various security measures to safely and securely protect our clients' assets.",
    "index07": "Both physical trading and leveraged trading are available",
    "index08": "Small transactions can be made from around $10, the spread is the narrowest in the industry, and the account balance can be used as collateral for leveraged transactions. Only GMG INT can charge leverage fees.",
    "index09": "Tokens designed to empower the GMG INT community",
    "index10": "Unus Sed LEO is an application token designed to help users who seek to maximize the benefits and functions of the GMG INT trading platform meet their needs.",
    "index11": "Tokens designed to empower the GMG INT community",
    "index12": "Open the way to a better life",
    "index13": "Everyone can own crypto. Everyone can trade crypto software. Here's how Bitget can take you a step further.",
    "index14": "Innovative Products",
    "index15": "One-click copy trade",
    "index16": "Do not convert tokens when trading",
    "index17": "Major derivatives exchanges that support USDC margin",
    "index18": "Risk control through hot and cold wallet isolation",
    "index19": "12 a+ ratings from SSL Labs",
    "index20": "Trusted security supported by Suntwin Technology, Green Pine Cloud Security, HEAP and Armors",
    "index21": "Excellent customer service",
    "index22": "24/7 online support in multiple languages",
    "index23": "One-to-one support for VIP customers",
    "index24": "Community Reward Center",
    "index25": "Built by traders for traders",
    "index26": "Trade various digital assets such as Bitcoin, Ethereum, Solana and dogcoin with low transaction costs",
    "index27": "The tools and information you need to buy, sell, trade, invest and use cryptocurrencies",
    "index28": "Industry-leading security",
  },
  "langNew":{
    "szhb": "Crypto",
    "gjs": "Metal",
    "yy": "Crude",
    "jy": "Trade",
    "jmhb": "Crypto",
    "yxhy": "Perpetual contract",
    "gdjy": "Pending order",
    "khh": "Account Opening",
    "qsrkhh": "Please enter your account bank",
    "yhkh": "Bank card number",
    "qsryhkh": "Please enter your bank card number",
    "mnzh":"Demo Account",
    "cjmnzhcg":"Demo Account created successfully",
    "tcmnzh":"Exit Demo Account",
   }
}



// WEBPACK FOOTER //
// ./src/lang/en.js